import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppCommonFunctionsService {

  constructor(
              private apiService: ApiService
  ) { }

  getStaticFileUrl(fileName: string): string {
    let fileNameUriEncoded = window.encodeURIComponent(fileName);
    return environment.staticFileLocation + fileNameUriEncoded;
  }
}
